export default {
  install: (app) => {
    app.config.globalProperties.$toast = useToastStore();
    app.config.globalProperties.$system = useSystemStore();
    app.config.globalProperties.$auth = useAuthStore();
    app.config.globalProperties.$loading = useLoadingStore();
  }
}
